






















































































































































































































































































































































































































































import { DashboardApi } from '@/api/dashboard';
import { createPartnerPracticeDashboardResponse, PartnerPracticeDashboardResponse } from '@/api/responses/dashboard/partner-practice-dashboard-response';
import { Forbidden } from '@/api/responses/forbidden';
import loading from '@/components/loading.vue';
import toggleButton from '@/components/toggle-button.vue';
import layout from '@/layouts/app.vue';
import { PartnerPractice } from '@/shared/partner-practice';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const dashboardApi = new DashboardApi();

@Component({
    components: {
        layout,
        loading,
        toggleButton,
    },
})
export default class PartnerPracticeDashboard extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;

    private loading: boolean = true;
    private partnerPracticeFilter: string | null = null;
    private originalSourceFilter: string | null = null;
    private datePeriodFilter: number | null = 3;
    private dateFromFilter?: string | Date | null = null;
    private dateToFilter?: string | Date | null = null;
    private legalAdvisorFilter: string | null = null;
    private data: PartnerPracticeDashboardResponse = createPartnerPracticeDashboardResponse();
    private datePeriods = new Array<{ id: number | null, value: string }>(...[
        { id: 0, value: 'Current Day' },
        { id: 1, value: 'Current Week' },
        { id: 2, value: 'Previous Week' },
        { id: 3, value: 'Current Month' },
        { id: 4, value: 'Previous Month' },
        { id: 5, value: 'Current Quarter' },
        { id: 6, value: 'Previous Quarter' },
        { id: 7, value: 'Current Year' },
        { id: 8, value: 'Previous Year' },
        { id: 9, value: 'Custom Dates' },
    ]);

    private get isCustomDatePeriod(): boolean {
        return this.datePeriodFilter === 9;
    }

    @Watch('datePeriodFilter')
    private async onDatePeriodFilterChanged(): Promise<void> {
        this.dateFromFilter = null;
        this.dateToFilter = null;
    }

    private async fetchDashboardDataAsync(): Promise<void> {
        try {
            this.data = await dashboardApi.getPartnerPracticeDashboardDataAsync({
                datePeriod: this.datePeriodFilter,
                dateFrom: this.dateFromFilter,
                dateTo: this.dateToFilter,
                partnerPracticeId: this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.partnerPracticeFilter,
                originalSourceTypeId: this.originalSourceFilter,
                legalAdvisorId: this.legalAdvisorFilter,
            });
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else {
                this.$snackbar.open({ message: `Could not load dashboard data.`, type: 'is-danger' });
            }
        }
    }

    private async loadDataAsync(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) { return; }

        this.loading = true;
        await this.fetchDashboardDataAsync();
        this.loading = false;
    }

    private async clearFiltersAsync(): Promise<void> {
        this.partnerPracticeFilter = null;
        this.originalSourceFilter = null;
        this.dateFromFilter = null;
        this.dateToFilter = null;
        this.datePeriodFilter = 3;
        this.legalAdvisorFilter = null;
    }

    public async mounted(): Promise<void> {
        this.loading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`types/loadPartnerPracticeTypesAsync`),
            this.fetchDashboardDataAsync(),
        ]);

        this.loading = false;
    }
}
